// Source: https://gist.github.com/jhurliman/1250118
// Licence: MIT


const encode    = unencoded   => new Buffer(unencoded || '').toString('base64')
const decode    = encoded     => new Buffer(encoded || '', 'base64').toString('utf8')
const urlEncode = unencoded   => encode(unencoded).replace(/\+/g, '-')
                                                  .replace(/\//g, '_')
                                                  .replace(/=+$/, '')
const urlDecode = encoded => {
    encoded = encoded.replace(/-/g, '+').replace(/_/g, '/')
    while (encoded.length % 4)
        encoded += '='
    return decode(encoded)
}


export const Base64 = { encode, decode, urlEncode, urlDecode, }
export default Base64

